import { render } from "./MailConfirmation.vue?vue&type=template&id=1ec4edb4"
import script from "./MailConfirmation.vue?vue&type=script&lang=js"
export * from "./MailConfirmation.vue?vue&type=script&lang=js"

import "./MailConfirmation.vue?vue&type=style&index=0&id=1ec4edb4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__